import { ReactNode } from "react";

/**
 * Shared "Something went wrong" panel for the signing flow's error states.
 * Renders the red badge + heading; callers supply the body copy and an
 * optional footer action (a retry button, a care-specialist card, etc.).
 */
export default function ArrangementStepError({
  message,
  children,
}: {
  message: ReactNode;
  children?: ReactNode;
}) {
  return (
    <div className="mx-auto max-w-2xl py-12 text-center">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
        <span className="text-2xl" aria-hidden="true">
          !
        </span>
      </div>
      <h2 className="mt-4 font-serif text-2xl text-evergreen">
        Something went wrong
      </h2>
      <p className="mx-auto mt-3 max-w-md text-soil">{message}</p>
      {children && <div className="mt-6 flex justify-center">{children}</div>}
    </div>
  );
}
